import axios from 'axios';
import '../../common/axiosInterceptor/axios-interceptor';

const BASE = `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api/v1/deviceDocuments`;

const request = (config) => axios.request({ authRequired: true, ...config });

export const listDeviceDocuments = (params) =>
  request({
    method: 'get',
    url: `${BASE}/list`,
    params,
  });

export const uploadDeviceDocument = (formData) =>
  request({
    method: 'post',
    url: `${BASE}/upload`,
    data: formData,
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
    timeout: 300000,
  });

export const processDeviceDocument = (documentId) =>
  request({
    method: 'post',
    url: `${BASE}/process/${documentId}`,
  });

export const activateDeviceDocument = (documentId, status) =>
  request({
    method: 'put',
    url: `${BASE}/activate/${documentId}`,
    data: { status },
    headers: { 'Content-Type': 'application/json' },
  });

export const listDeviceDocumentAssignments = (params) =>
  request({
    method: 'get',
    url: `${BASE}/assignments`,
    params,
  });

export const listDeviceDocumentMachines = (params) =>
  request({
    method: 'get',
    url: `${BASE}/machines`,
    params,
  });

export const assignDeviceDocument = (data) =>
  request({
    method: 'put',
    url: `${BASE}/assignments`,
    data,
    headers: { 'Content-Type': 'application/json' },
  });

export const unassignDeviceDocument = (data) =>
  request({
    method: 'delete',
    url: `${BASE}/assignments`,
    data,
    headers: { 'Content-Type': 'application/json' },
  });

export const bulkAssignDeviceDocument = (data) =>
  request({
    method: 'put',
    url: `${BASE}/assignments/bulk`,
    data,
    headers: { 'Content-Type': 'application/json' },
  });
